import axios from "axios";
import axiosRetry from "axios-retry";
import { navigateTo } from "./navigation";
import { RoutePaths } from "src/resources/enum";
import { toast } from "react-toastify";
import { Languages } from "src/resources/enum";
import { Cookie } from "@mui/icons-material";
import Cookies from "js-cookie";
import { t } from "i18next";

axiosRetry(axios, {
  retries: 2,
  retryDelay: axiosRetry.exponentialDelay,
  retryCondition: (error) => {
    return error.response?.status !== 400 && error.response?.status !== 500;
  },
});

axios.interceptors.request.use(
  function (config) {
    config.withCredentials = true;
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(null, (error) => {
  console.log(error);
  if (error && error.response?.status === 401) {
    navigateTo(RoutePaths.Login);
  } else return Promise.reject(error);
});

export function getHeaders() {
  const requestHeaders = {
    Authorization:
      "Basic " +
      btoa("APIBasicAdmin" + ":" + "87642ee2-c6db-4eac-9891-c2b901364633"),
    "Access-Control-Allow-Origin": "*",
    credentials: "include",
  };
  return requestHeaders;
}

export const postWithBasicHeader = async (url: string, data: any) => {
  var response = await axios.post(url, data, {
    method: "POST",
    headers: getHeaders(),
  });
  return await response;
};

export const getWithBasicHeader = async (url: string, data: any) => {
  var response = await axios.get(url, {
    method: "GET",
    headers: getHeaders(),
  });
  return await response;
};

const apiServices = {
  get: axios.get,
  post: axios.post,
  postWithBasicHeader: postWithBasicHeader,
  put: axios.put,
  delete: axios.delete,
  patch: axios.patch,
  isRequestCancelled: axios.isCancel,
};
export default apiServices;

export const handleResponse = (res: any, lang?: string) => {
  const language = lang ?? Cookies.get("language");

  console.log({ language });

  if (res && language) {
    if (
      (res.status === 200 &&
        (res.data?.OperationSucceeded === false ||
          res.data?.OperationResponse?.OperationSucceeded === false)) ||
      res.response?.status === 400 ||
      res.response?.status === 500
    ) {
      showServerErrorMessage(language, res);
      return false;
    } else if (res.response?.status === 401) {
      toast.error(t("somethingWentWrong"));
      navigateTo(RoutePaths.Login);
      return false;
    }
  }
  return true;
};

export function showServerErrorMessage(language: string, res: any) {
  console.log("res in show error ", res);
  const errorMsg =
    language === Languages.English
      ? res?.data?.ErrorDescriptionEn ||
        res?.response?.data?.ErrorDescriptionEn ||
        res?.data?.OperationResponse?.ErrorDescriptionEn
      : res?.data?.ErrorDescriptionAr ||
        res?.response?.data?.ErrorDescriptionAr ||
        res?.data?.OperationResponse?.ErrorDescriptionAr;

  toast.error(errorMsg || t("generalError"));
}
